import { render, staticRenderFns } from "./c-pharmacist-card.vue?vue&type=template&id=852d2f9e&scoped=true&"
import script from "./c-pharmacist-card.vue?vue&type=script&lang=js&"
export * from "./c-pharmacist-card.vue?vue&type=script&lang=js&"
import style0 from "./c-pharmacist-card.vue?vue&type=style&index=0&id=852d2f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d2f9e",
  null
  
)

export default component.exports